import searchConstants from "../_constants/searchConstants";
import searchService from "../_services/searchService";

/* ---------------------------------------------------
  QUICK SEARCH
----------------------------------------------------- */

export const search = payload => dispatch => {
  const { data, onSuccess, onError } = payload;

  searchService
    .performSearch(data)
    .then(response => {
      const { results, lastResult } = response;
      dispatch(searchSuccess(results));
      dispatch(changeLastResult(lastResult));
      dispatch(changeFilter(data));
    })
    .catch(err => {
      dispatch(searchSuccess([]));
      dispatch(changeLastResult(null));
      dispatch(changeFilter(null));
    });
};
/* ---------------------------------------------------
  SEARCH SUCCESS
----------------------------------------------------- */
const searchSuccess = payload => ({
  type: searchConstants.SEARCH,
  payload
});
/* ---------------------------------------------------
  CLEAR SEARCH RESULTS
----------------------------------------------------- */
export const clearSearchResults = payload => ({
  type: searchConstants.CLEAR_SEARCH_RESULTS,
  payload
});

/* ---------------------------------------------------
  CHANGE FILTER
----------------------------------------------------- */
const changeFilter = payload => ({
  type: searchConstants.CHANGE_FILTER,
  payload
});

/* ---------------------------------------------------
  CHANGE LAST RESULT
----------------------------------------------------- */
const changeLastResult = payload => ({
  type: searchConstants.CHANGE_LAST_RESULT,
  payload
});

/* ---------------------------------------------------
 LOAD MORE SEARCH RESULTS
----------------------------------------------------- */

export const loadMoreSearchResults = payload => dispatch => {
  const { lastResult, filter } = payload;

  searchService
    .loadMoreResults(lastResult, filter)
    .then(data => {
      const { results, lastResult } = data;

      dispatch(loadMoreSearchResultsSuccess(results));
      dispatch(changeLastResult(lastResult));
    })
    .catch(err => {
      dispatch(loadMoreSearchResultsSuccess([]));
      dispatch(changeLastResult(null));
      dispatch(changeFilter(null));
    });
};
/* ---------------------------------------------------
  LOAD MORE SEARCH RESULTS SUCCESS
----------------------------------------------------- */
const loadMoreSearchResultsSuccess = payload => ({
  type: searchConstants.LOAD_MORE_SEARCH_RESULTS,
  payload
});



// WEBPACK FOOTER //
// ./src/_actions/searchActions.js